import { BaseBlockModel, defineBlockSchema } from '@blocksuite/store';
export const defaultAttachmentProps = {
    name: '',
    size: 0,
    type: 'application/octet-stream',
    sourceId: undefined,
    caption: undefined,
    embed: false,
};
export const AttachmentBlockSchema = defineBlockSchema({
    flavour: 'affine:attachment',
    props: () => defaultAttachmentProps,
    metadata: {
        version: 1,
        role: 'content',
        parent: ['affine:note'],
    },
    toModel: () => new AttachmentBlockModel(),
});
export class AttachmentBlockModel extends BaseBlockModel {
}
//# sourceMappingURL=attachment-model.js.map